/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PresetUpdateVisibility = typeof PresetUpdateVisibility[keyof typeof PresetUpdateVisibility] | null;


export const PresetUpdateVisibility = {
  public: 'public',
  private: 'private',
} as const;
